import twitter from 'twitter-text';

export default (content) => {
  let source = content;
  source = source.replace(/\uFF20/g, '@');
  source = source.replace(/\&#39;/g, "'");
  source = source.replace(/@\[(.+?)\](?:\((\d+)\))?/g, '[$1-id:$2](mention)');
  source = source.replace(/@preview\[(.+?)\](?:\((\d+)\))?/g, '[$1-id:$2](preview)');

  const hashtags = twitter.extractHashtags(source);

  if (hashtags.length) {
    hashtags.forEach((hashtag) => {
      source = source.replace(`#${hashtag}`, `[${hashtag}](hashtag)`);
    });
  }

  return source;
};
